<script setup lang="ts">
import { getMaterialDefault } from "~/common/defaults/material.default";
import { calculateColorStops } from "~/common/helpers/calculate-color-stops";
import type { MaterialTrimmed } from "~/common/interfaces/material-trimmed";

/** @todo temporary solution to prevent hydration mismatch issue */
const ariaId = useId();

const props = defineProps({
	material: {
		type: Object as PropType<MaterialTrimmed>,
		default () {
			return getMaterialDefault();
		}
	}
});

const backgroundStyles = computed(() => {
	const colorStops = calculateColorStops(props.material.colors.length);
	const rules = props.material.colors.map((hex, i) => {
		return `${hex} ${colorStops[i]}`;
	});

	const styles = {
		border: "",
		background: `linear-gradient(-45deg, ${rules})`
	};

	const hasWhiteColor = props.material.colors.find(hex => hex.toLowerCase() === "#ffffff");
	if (hasWhiteColor) {
		styles.border = "1px solid #e7e7ec";
	}

	return styles;
});
</script>

<template>
	<VTooltip
		:triggers="['hover', 'click']"
		placement="top"
		:distance="8"
		:aria-id="ariaId"
	>
		<label>
			<div
				class="w-[28px] h-[28px] flex justify-center items-center rounded-full border-2 border-transparent"
			>
				<div
					class="w-4 h-4 rounded-full"
					:style="backgroundStyles"
				>
				</div>
			</div>
		</label>
		<template #popper>
			<span class="text-xs">{{ material.name }}</span>
		</template>
	</VTooltip>
</template>
